import type {
  ContactMessage,
  ContactMessageListParams,
  ContactMessageListResult,
  ContactMessageStatus,
} from '@/types/contactMessage.types';
import { cleanParams } from '@/utils/params.util';

import { apiClient } from './api.service';

export const contactMessagesApi = {
  list: (params: ContactMessageListParams): Promise<ContactMessageListResult> =>
    apiClient
      .get<ContactMessageListResult>('/admin/contact-messages', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  updateStatus: (id: string, status: ContactMessageStatus): Promise<ContactMessage> =>
    apiClient
      .patch<ContactMessage>(`/admin/contact-messages/${id}`, { status })
      .then((r) => r.data),
};
